module.exports = __webpack_public_path__ + "static/media/edit-profile.0881a54f.png";